<template>
    <footer
        class="footer d-flex align-items-center justify-content-center bg-white border-top"
    >
        <span class="mr-2">Desenvolvido por</span>
        <img
            class="img-fluid"
            src="@/assets/images/logo-simworx.png"
            alt="Logo Simworx"
        />
    </footer>
</template>

<script>
export default {
    name: "SimbarFooter"
};
</script>

<style lang="scss" scoped>
.footer {
    min-height: 30px;
    font-size: 0.875rem;
    img {
        height: 20px;
    }
}
</style>
